import React from 'react';
import TextRow from '../../components/text-row';
import { getProp, getPropMarked } from '../utils';

const TextRowPreview = (props) => {
  const title = getProp(props, 'title');
  const hideTitle = getProp(props, 'hideTitle');
  const left = getPropMarked(props, 'left');
  const right = getPropMarked(props, 'right');

  return <TextRow title={title} hideTitle={hideTitle} left={left} right={right} />;
};

export default TextRowPreview;
